import AdsReports, { type ReportsPlatformConfig } from "@/components/AdsReports";

const GOOGLE_ADS_REPORTS: ReportsPlatformConfig = {
  apiBase: "/admin/google-ads/ai",
  description:
    "Analiza cuenta, palabras clave, búsquedas reales, anuncios y registros de ReservaManager, y lo compara con el informe anterior. Tarda 1-3 minutos; puedes seguir usando el panel.",
};

export default function GoogleAdsReports({ onAskAssistant }: { onAskAssistant: (text: string) => void }) {
  return <AdsReports config={GOOGLE_ADS_REPORTS} onAskAssistant={onAskAssistant} />;
}
